'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cart = exports.CLASS_VISIBLE = exports.CLASS_DISABLED = exports.IS_HIDDEN = exports.CLASS_HAS_NO_ITEMS = exports.CART_DRAWER_TOGGLE = exports.CART_DRAWER_MESSAGE = exports.CART_FREE_SAMPLE_ADD_BTN = exports.CART_FREE_SAMPLE_BUTTON = exports.CART_ALTERNATE_PAYMENT_MONEY = exports.CART_ORIGINAL_SUBTOTAL = exports.CART_SUBTOTAL = exports.CART_PRODUCT_SELECTOR = exports.CART_ITEM_COUNT = exports.CART_PRODUCTS_CONTAINER = exports.CART_PRODUCT_REMOVE = exports.CART_DRAWER_MESSAGE_MAX_VALUE = exports.CART_DRAWER_MESSAGE_MIN_VALUE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _CartQuantitySelector = require('./../../objects/quantity/CartQuantitySelector');

var _ProductThumbnail = require('./../../objects/product/ProductThumbnail');

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _FreeSampleCarousel = require('../../sections/free-sample/FreeSampleCarousel');

var _FreeSample = require('../../sections/free-sample/FreeSample');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Attrs
/*
 *  Cart
 *    Reusable Cart class, used on the cart template and drawer
 *
 *  Version:
 *    1.0.0 - 2020/06/26
 */

var CART_DRAWER_MESSAGE_MIN_VALUE = exports.CART_DRAWER_MESSAGE_MIN_VALUE = 'data-cart-drawer-message-min-spend';
var CART_DRAWER_MESSAGE_MAX_VALUE = exports.CART_DRAWER_MESSAGE_MAX_VALUE = 'data-cart-drawer-message-max-spend';

// Selectors
var CART_PRODUCT_REMOVE = exports.CART_PRODUCT_REMOVE = '[data-cart-remove]';
var CART_PRODUCTS_CONTAINER = exports.CART_PRODUCTS_CONTAINER = '[data-cart-products]';
var CART_ITEM_COUNT = exports.CART_ITEM_COUNT = '[data-cart-item-count]';
var CART_PRODUCT_SELECTOR = exports.CART_PRODUCT_SELECTOR = 'data-cart-product';
var CART_SUBTOTAL = exports.CART_SUBTOTAL = '[data-cart-subtotal]';
var CART_ORIGINAL_SUBTOTAL = exports.CART_ORIGINAL_SUBTOTAL = '[data-cart-original-subtotal]';
var CART_ALTERNATE_PAYMENT_MONEY = exports.CART_ALTERNATE_PAYMENT_MONEY = '[data-alternate-money-price]';
var CART_FREE_SAMPLE_BUTTON = exports.CART_FREE_SAMPLE_BUTTON = '[data-free-sample-button]';
var CART_FREE_SAMPLE_ADD_BTN = exports.CART_FREE_SAMPLE_ADD_BTN = '[data-free-sample-add-btn]';
var CART_DRAWER_MESSAGE = exports.CART_DRAWER_MESSAGE = '[data-cart-drawer-message]';
var CART_DRAWER_TOGGLE = exports.CART_DRAWER_TOGGLE = '[data-cart-drawer-toggle]';

var SELECTOR_FREE_SAMPLE = '[data-free-sample]';
var SELECTOR_REMAINING = '[data-cart-drawer-remaining-value]';
var SELECTOR_PROMOBAR = '[data-cart-drawer-promo-bar]';

//Classes
var CLASS_HAS_NO_ITEMS = exports.CLASS_HAS_NO_ITEMS = 'has-no-items';
var IS_HIDDEN = exports.IS_HIDDEN = 'is-hidden';
var CLASS_DISABLED = exports.CLASS_DISABLED = 'is-disabled';
var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';

var Cart = exports.Cart = function () {
  function Cart(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Cart);

    this.container = container;
    this.qtySelectors = [];

    this.productsContainer = container.find(CART_PRODUCTS_CONTAINER);
    this.subtotal = container.find(CART_SUBTOTAL);
    this.originalSubtotal = container.find(CART_ORIGINAL_SUBTOTAL);
    this.itemsCount = container.find(CART_ITEM_COUNT);
    this.alternatePaymentPrice = container.find(CART_ALTERNATE_PAYMENT_MONEY);
    this.freeSampleButton = container.find(CART_FREE_SAMPLE_BUTTON);
    this.freeSampleAddBtn = this.container.find(CART_FREE_SAMPLE_ADD_BTN);
    this.cartDrawerMessage = container.find(CART_DRAWER_MESSAGE);
    this.cartDrawerPromoBar = container.find(SELECTOR_PROMOBAR);

    this.setupQuantitySelectors();
    this.setupFreeSample();
    (0, _jquery2.default)(document).on('click touch', CART_DRAWER_TOGGLE, function (e) {
      return _this.cartToggle(e);
    });
    (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
      return _this.onCartFinished();
    });
    (0, _jquery2.default)(document).on('click touchend', CART_PRODUCT_REMOVE, function (e) {
      return _this.removeItem(e);
    });
  }

  (0, _createClass3.default)(Cart, [{
    key: 'cartToggle',
    value: function cartToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      this.updatePromoMessages();
    }
  }, {
    key: 'onCartFinished',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var cart, cartContent, originalSubtotal, subtotal, count;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //Fetch the AJAX view for the cart
                cart = (0, _pcSlateTools.getCurrentCart)();
                cartContent = '';
                _context.prev = 2;
                _context.next = 5;
                return new Promise(function (resolve, reject) {
                  _jquery2.default.ajax({
                    url: '/cart',
                    data: { view: 'ajax' },
                    success: function success(d) {
                      return resolve(d);
                    },
                    error: function error(jqXHR, status, _error) {
                      return reject(_error);
                    }
                  });
                });

              case 5:
                cartContent = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                //Error when fetching cart body
                console.error(_context.t0);

              case 11:
                if (!(!cartContent || !cartContent.length)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt('return');

              case 13:

                //Update HTML of our cart products
                this.productsContainer.html(cartContent);

                //Update the subtotals
                originalSubtotal = cart.original_total_price;

                this.originalSubtotal.attr('data-money', originalSubtotal);
                this.originalSubtotal.html((0, _pcSlateTools.printMoney)(originalSubtotal));

                subtotal = cart.items_subtotal_price;

                this.subtotal.attr('data-money', subtotal);
                this.subtotal.html((0, _pcSlateTools.printMoney)(subtotal));

                if (originalSubtotal > subtotal) {
                  this.originalSubtotal.removeClass(IS_HIDDEN);
                } else {
                  this.originalSubtotal.addClass(IS_HIDDEN);
                }

                // Update alternate payment price
                this.alternatePaymentPrice.html((0, _pcSlateTools.printMoney)(subtotal / 4, 'money_format'));

                count = cart.item_count;

                //Update content based on cart items

                if (count === 0) {
                  this.itemsCount.html('');
                  this.container.addClass(CLASS_HAS_NO_ITEMS);
                } else {
                  this.cartDrawerMessage.removeClass(CLASS_VISIBLE);
                  this.container.removeClass(CLASS_HAS_NO_ITEMS);
                  this.itemsCount.html('(' + count + ')');
                }

                this.updatePromoMessages(cart);

                //Re-attach Quantity Selectors with their logic.
                this.setupQuantitySelectors();

                (0, _ProductThumbnail.InitializeInactiveThumbnails)();

                if (cart.item_count > 0) this.validateSampleProducts(cart);

                //Set up class if not there on page load
                this.setupFreeSampleCarousel();
                //Update the slick carousel for free samples
                if (this.freeSampleCarousel) this.freeSampleCarousel.updateSampleCarousel();

                if (this.moveUpsellCarousel) this.moveUpsellCarousel();

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function onCartFinished() {
        return _ref.apply(this, arguments);
      }

      return onCartFinished;
    }()
  }, {
    key: 'updatePromoMessages',
    value: function updatePromoMessages() {
      var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _pcSlateTools.getCurrentCart)();

      //Adjusted total, subtotal of original line price excluding free products.
      //Free products don't count towards our total that the line-item script
      //uses as its calculation. Bundle discounts are applied before the
      //Tier discounts are applied. Adjusted total takes final into account for these.
      var adjustedTotal = cart.items.reduce(function (x, item) {
        if (item.original_line_price == item.total_discount) return x;
        return x += item.original_line_price;
      }, 0);

      adjustedTotal = adjustedTotal / 100;

      var promoMax = false;

      //Update the visibility of our cart drawer messages.
      this.cartDrawerMessage.each(function (i, e) {
        var message = (0, _jquery2.default)(e);
        var min = message.attr(CART_DRAWER_MESSAGE_MIN_VALUE) || 0;
        var max = message.attr(CART_DRAWER_MESSAGE_MAX_VALUE) || 0;
        max = parseFloat(max);
        var remainingElement = message.find(SELECTOR_REMAINING);

        if (adjustedTotal > 0 && adjustedTotal >= min && adjustedTotal < max) {
          message.addClass(CLASS_VISIBLE);
          promoMax = max;

          if (remainingElement.length) {
            remainingElement.html((0, _pcSlateTools.printMoney)(max * 100 - adjustedTotal * 100));
          }
        } else {
          message.removeClass(CLASS_VISIBLE);
        }
      });

      if (this.cartDrawerPromoBar.length) {
        var promoParentEl = this.cartDrawerPromoBar.parent();
        if (promoMax) {
          var percent = adjustedTotal / promoMax * 100;
          this.cartDrawerPromoBar.css('width', percent + '%');
          promoParentEl.addClass(CLASS_VISIBLE);
        } else {
          promoParentEl.removeClass(CLASS_VISIBLE);
        }
      }
    }
  }, {
    key: 'validateSampleProducts',
    value: function validateSampleProducts(cart) {
      //Only one sample allowed per cart
      //You can't checkout with only sample products
      var nonSampleCount = cart.items.reduce(function (count, item) {
        if (!item.properties || !item.properties._free_sample) {
          return count = count + 1;
        }
        return count;
      }, 0);

      var sampleCount = 0;

      //Default mapping, used for comparison
      var itemsDefaultMapping = cart.items.map(function (i) {
        return i.quantity;
      });

      //Map the items to remove, if any
      var itemsToRemove = cart.items.map(function (item) {
        if (item.properties && item.properties['_free_sample']) {
          sampleCount++;
          if (sampleCount > 1 || nonSampleCount == 0) return 0;
          return 1;
        }
        //Normal Product, return the quantity.
        return item.quantity;
      });

      //if itemsToRemove != default mapping run the removeCartItems
      var cartItemsSame = itemsDefaultMapping.every(function (currentItem, i) {
        return currentItem == itemsToRemove[i];
      });

      if (!cartItemsSame) this.removeItemsFromCart(itemsToRemove);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(e) {
      e.preventDefault();
      e.stopPropagation();

      var self = (0, _jquery2.default)(e.currentTarget);
      var product = self.closest('[' + CART_PRODUCT_SELECTOR + ']');
      var index = product.attr('data-index');

      //Now remove Item
      try {
        (0, _pcSlateTools.removeFromCart)(index);
      } catch (e) {
        console.error(e);
      }
    }

    //Remove an object of items from the cart at once

  }, {
    key: 'removeItemsFromCart',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(remove) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (remove.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return (0, _pcSlateTools.shopifyPost)('/cart/update.js', { updates: remove }).then(function (e) {
                  return (0, _pcSlateTools.getCart)();
                }).catch(function (ex) {
                  return console.error(ex);
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeItemsFromCart(_x2) {
        return _ref2.apply(this, arguments);
      }

      return removeItemsFromCart;
    }()
  }, {
    key: 'setupQuantitySelectors',
    value: function setupQuantitySelectors() {
      var _this2 = this;

      //Destroy
      this.qtySelectors.forEach(function (e) {
        return e.destroy();
      });

      //Now recreate
      this.qtySelectors = [];

      (0, _jquery2.default)('[' + CART_PRODUCT_SELECTOR + ']').each(function (e, i) {
        var self = (0, _jquery2.default)(i);
        var index = self.attr('data-index');
        _this2.qtySelectors.push(new _CartQuantitySelector.CartQuantitySelector(index, self));
      });
    }
  }, {
    key: 'setupFreeSample',
    value: function setupFreeSample() {
      this.freeSampleButton = new _FreeSample.FreeSample(this.container);
      this.setupFreeSampleCarousel();
    }
  }, {
    key: 'setupFreeSampleCarousel',
    value: function setupFreeSampleCarousel() {
      if (this.freeSampleCarousel) return;
      this.freeSampleCarouselContainer = this.container.find(SELECTOR_FREE_SAMPLE);
      this.freeSampleCarousel = new _FreeSampleCarousel.FreeSampleCarousel(this.freeSampleCarouselContainer);
    }
  }]);
  return Cart;
}();